import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { ApisService } from '../../services/apis.service';
import { inject } from '@angular/core';
import { tap, catchError, throwError, finalize } from 'rxjs';
import { AppConstants } from '../../app-constants';
import { SharedService } from '../../services/shared.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
 const apis = inject(ApisService);
const sharedService = inject(SharedService);

sharedService.addRequest(req); // ✅ Always track the request

const clonedRequest = req.clone({ withCredentials: true });

return next(clonedRequest).pipe(
  tap((event: any) => {
    if (event instanceof HttpResponse) {
      if ((event.body.success === 0 || event.body.success === '0') &&
          req.url !== "/model/service/generic/user/change-password") {
        const errortoast = req.headers.get('errortoast');
        if (!errortoast && req.url !== AppConstants.apis_end_points.login) {
          sharedService.showErrorToaster(event.body.message);
        }
      }
    }
  }),
  catchError((err) => {
    if (req.url !== AppConstants.apis_end_points.login) {
      if (err.status === 401) {
        const isLoggedIn = sharedService.getSession(AppConstants.LocalStorage.IsLoggedIn);
        if (isLoggedIn) {
          apis.cleanupOnLogout();
        }
      } else if (!navigator.onLine) {
        sharedService.showErrorToaster('Please check your internet connection.');
      } else if (err.status === 403) {
        sharedService.showErrorToaster(err);
      } else {
        const msg = sharedService.getErrorMessage(err);
        sharedService.showErrorToaster(msg);
      }
    }
    return throwError(() => err);
  }),
  finalize(() => {
    console.log(req,'Opppppppppppppppppp')
    sharedService.removeRequest(req); // ✅ Always clean up request
  })
);
}
